import { 
    PAYMENT_REQUEST, 
    PAYMENT_SUCCESS, 
    PAYMENT_FAILURE,
    PaymentItem,
    PaymentResponse,
    PaymentActionTypes
  } from './types';
  
  export const paymentRequest = (items: PaymentItem[]): PaymentActionTypes => ({
    type: PAYMENT_REQUEST,
    payload: items,
  });
  
  export const paymentSuccess = (response: PaymentResponse): PaymentActionTypes => ({
    type: PAYMENT_SUCCESS,
    payload: response,
  });
  
  export const paymentFailure = (error: string): PaymentActionTypes => ({
    type: PAYMENT_FAILURE,
    payload: error,
  });